// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__Eg7bD","resendInfoText":"OnGoingPaymentBox_resendInfoText__136lL"};